
<template>
<div 
    v-if="isOpen"
    ref="drawer" 
    id="agDrawer" 
    :class="`agDrawer-${orientation}`"
    :style="{'width':widthStr, 'height': heightStr, 'max-width': maxWidthStr, 'max-height': maxHeightStr}">
    <div id="agDrawer-navbar" :class="`agDrawer-navbar-${orientation}`">
        <div id="agDrawer-navbarCustomButtons">
            <slot name="navbarCustomButtons"></slot>
        </div>
        <b-button 
            id="agDrawer-handle" 
            class="agImageButton" 
            v-b-tooltip.hover
            title="Resize drawer"
            @mousedown="handle_mousedown">
            <fa icon="grip-lines"/>
        </b-button>
         <b-button 
            id="agDrawer-closeButton" 
            class="agImageButton" 
            v-b-tooltip.hover
            title="Close drawer"
            @click="closeButton_click">
            <fa icon="times"/>
        </b-button>
    </div>
    <hr v-if="orientation == 'bottom'">
    <div id="agDrawer-content" :class="`agDrawer-content-${orientation}`" ref="content">
        <slot name="content"></slot>
    </div>
</div>    
</template>






<script>

// components

// modules


export default {
    name: "ag-drawer",
    components: {
    },
    props:{
        orientation: String,
        initialHeight: Number,
        initialWidth: Number,
        maxHeight: Number,
        minHeight: Number,
        maxWidth: Number,
        minWidth: Number
    },
    data(){
        return {
            isOpen: false,
            lastPoint: null
        };
    },
    computed: {

        widthStr() {
            if(this.initialWidth) 
                return this.initialWidth + "px";
            else if(this.orientation == "bottom")
                return "100%";
            else
                return "250px";
        },

        heightStr() {
            if(this.initialHeight)
                return this.initialHeight + "px";
            else if(this.orientation == "left" || this.orientation == "right")
                return "100%";
            else
                return "250px";
        },

        maxWidthStr() {
            if(this.maxWidth)
                return `${this.maxWidth}px`;
            else
                return "100%";
        },

        maxHeightStr() {
            if(this.maxHeight)
                return `${this.maxHeight}px`;
            else
                return "100%";
        },

        left() {

        },

        right() {

        },

        bottom() {

        },

        top() {

        }
    },
    watch: {
      
    },

    created() {

    },

    mounted() {
      if(this.draggable) {

      }
    },

    methods: {

        // UI Events

        handle_mousedown(e) {
            if(this.orientation == "bottom") 
                this.lastPoint = e.screenY;
            else
                this.lastPoint = e.screenX;

            window.addEventListener("mousemove", this.window_mousemove);
            window.addEventListener("mouseup", this.window_mouseup);
        },

        window_mousemove(e) {
            if(this.orientation == "bottom") {
                var dy = this.lastPoint - e.screenY;
                this.lastPoint = e.screenY;
                var newHeight = (this.$refs.drawer.clientHeight + 2) + dy; // +2 for borders
                var minHeight = 35;
                if(this.minHeight)
                    minHeight = this.minHeight;
                if(newHeight > minHeight && newHeight < this.maxHeight) {
                    this.$refs.drawer.style.height =  newHeight + "px";
                }
            }
            else if(this.orientation == "left") {
                var dx = e.screenX - this.lastPoint;
                this.lastPoint = e.screenX;
                var newWidth = (this.$refs.drawer.clientWidth + 2) + dx; // +2 for borders
                var minWidth = 35;
                if(this.minWidth)
                    minWidth = this.minWidth;
                if(newWidth > minWidth && newWidth < this.maxWidth) {
                    this.$refs.drawer.style.width =  newWidth + "px";
                }
            }
            else if(this.orientation == "right") {
                var dx = this.lastPoint - e.screenX;
                this.lastPoint = e.screenX;
                var newWidth = (this.$refs.drawer.clientWidth + 2) + dx; // +2 for borders
                var minWidth = 35;
                if(this.minWidth)
                    minWidth = this.minWidth;
                if(newWidth > minWidth && newWidth < this.maxWidth) {
                    this.$refs.drawer.style.width =  newWidth + "px";
                }
            }
        },

        window_mouseup() {
            window.removeEventListener("mousemove", this.window_mousemove);
            window.removeEventListener("mouseup", this.window_mouseup);
        },  


        closeButton_click() {
            this.close();
            this.$emit("closed");
        },

        // emitted Events


        // other

        open() {
            this.isOpen = true;
        },

        close() {
            this.isOpen = false;
        },

        scrollToTop() {
            var content = this.$refs.content;
            content.scrollTop = 0;
        },

        scrollToBottom() {
            var content = this.$refs.content;
            content.scrollTop = content.scrollHeight;
        },
    }
}

</script>






<style scoped lang="css">

#agDrawer {
    overflow: hidden;
    z-index: 900;

    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
}

#agDrawer-content {
    overflow: auto;
    position: relative;
}

hr {
    margin: 5px auto;
}

#agDrawer-navbar {
    position: relative;
    text-align: center;
}

#agDrawer-handle {
    position: relative;
    width: 30px;
    height: 30px;
    font-size: 28px;

}

#agDrawer-closeButton {
    float: right;
    margin-right: 10px;
    margin-top: 2.5px;
    font-size: 22px;
}





/**** BOTTOM *****/

.agDrawer-bottom {
    position: fixed;
    left: 0px;
    bottom: 0px;
    background-color: red;


    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #F8F8FF;
}

.agDrawer-bottom #agDrawer-navbarCustomButtons button {
    float: left;
    margin: 2.5px 10px 0px 10px;
    font-size: 22px;
}

.agDrawer-bottom #agDrawer-content {
    width: calc(100% - 40px);
    height: calc(100% - 55px);
    margin: 10px;
}

.agDrawer-bottom #agDrawer-handle {
    cursor: ns-resize !important;
}


/**** LEFT *****/

.agDrawer-left {
    position: fixed;
    left: 0px;
    bottom: 0px;
    background-color: red;


    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #F8F8FF;
}

.agDrawer-left #agDrawer-navbar {
    display: inline-block;
    width: 35px;
    height: 100%;
    float: right;

       
    border-left-style: solid;
    border-left-width: 1px;
    border-left-color: lightgray;
}

.agDrawer-left #agDrawer-navbarCustomButtons button {
    float: bottom;
    margin: 2.5px 10px 0px 10px;
    font-size: 22px;
}

.agDrawer-left  #agDrawer-content {
    display: inline-block;
    width: calc(100% - 55px);
    height: calc(100% - 40px);
    margin: 10px;
    overflow: auto;
}

.agDrawer-left  #agDrawer-handle {
    position: absolute;
    top: 50%;
    margin-top: -14px;
    margin-left: -10px;
    transform: rotate(90deg);
    cursor: ew-resize !important;
}



/**** RIGHT *****/

.agDrawer-right  {
    position: fixed;
    left: 0px;
    bottom: 0px;
    background-color: red;


    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #F8F8FF;
}

.agDrawer-right #agDrawer-content {
    width: calc(100% - 50px);
    height: calc(100% - 45px);
    margin: 10px 25px 0px 25px;
    overflow: auto;
}

.agDrawer-right #agDrawer-handle {
    cursor: ew-resize !important;
}





</style>



// WEBPACK FOOTER //
// src/components/ui/Drawer.vue